var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcCar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ic-car",
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.991,
    height: 17.993,
    viewBox: "0 0 23.991 17.993",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "car-solid",
    d: "M23.432,69.248H20.627l-.78-1.949A5.221,5.221,0,0,0,14.975,64H9.024a5.223,5.223,0,0,0-4.873,3.3l-.78,1.949H.566a.562.562,0,0,0-.545.7L.3,71.071a.562.562,0,0,0,.545.426h.94A2.978,2.978,0,0,0,.753,73.746V76A2.974,2.974,0,0,0,1.5,77.96v2.534a1.5,1.5,0,0,0,1.5,1.5H4.5a1.5,1.5,0,0,0,1.5-1.5v-1.5H18v1.5a1.5,1.5,0,0,0,1.5,1.5H21a1.5,1.5,0,0,0,1.5-1.5V77.96A2.973,2.973,0,0,0,23.245,76V73.746A2.979,2.979,0,0,0,22.211,71.5h.94a.562.562,0,0,0,.545-.426l.281-1.125A.563.563,0,0,0,23.432,69.248Zm-16.5-.835A2.249,2.249,0,0,1,9.024,67h5.951a2.249,2.249,0,0,1,2.088,1.414L18,70.748H6ZM4.5,75.986A1.495,1.495,0,1,1,4.5,73a2.885,2.885,0,0,1,2.249,2.242C6.751,76.136,5.4,75.986,4.5,75.986Zm14.995,0c-.9,0-2.249.149-2.249-.747A2.885,2.885,0,0,1,19.5,73a1.495,1.495,0,1,1,0,2.99Z",
    transform: "translate(-0.003 -64)",
    fill: "#146f62"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCar);
export default __webpack_public_path__ + "static/media/ic-car.4900cb43acf8538d90fe0fdf4fe9b4ce.svg";
export { ForwardRef as ReactComponent };